import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import { font, greys } from 'assets/themes/theme-default'

const ListInfosRow = styled(Row)`
  background-color: ${greys.light3};
  &:nth-child(even) {
    background-color: ${greys.light3};
  }
`

const ColValueWrapper = styled(Col)`
  font-weight: ${font.weight.bold};
`
const Icon = styled(SVG)`
  width: 24px;
  height: 24px;
  fill: ${props => props.theme.colors.color2.bg};
  vertical-align: middle;
`

const renderRow = props => {
  const { label, value, icon } = props

  return (
    <ListInfosRow type="flex" style={{ alignItems: 'center', padding: '5px 0' }}>
      <Col span={12}>
        <Row type="flex" gutter={15} style={{ alignItems: 'center' }}>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Icon svg={icon} />
          </Col>
          <Col span={18}>{label}</Col>
        </Row>
      </Col>
      <ColValueWrapper span={12}>{value}</ColValueWrapper>
    </ListInfosRow>
  )
}

renderRow.propTypes = {
  label: PropTypes.shape().isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.shape().isRequired
}

export default renderRow
